import { useEffect } from "react"
import { useInView } from "react-intersection-observer"
import { GAEvent } from "../modules/GoogleAnalytics"
import { useMediaQuery } from "@material-ui/core"
import { useTrack } from "@hackler/react-sdk"

interface Params {
  message: string,
  eventKey?: string
}
export default function useScrollImpressionLog({ message, eventKey }: Params) {
  const track = useTrack()
  const isDesktop = useMediaQuery("(min-width: 850px)")
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true,
    delay: 100,
  })
  useEffect(() => {
    if (inView) {
      GAEvent({
        action: "Scroll Impression",
        category: "MainPage",
        label: `[${isDesktop ? "PC" : "Mobile"}] ${message}`,
      })
      if (eventKey) track({ key: eventKey })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [inView, isDesktop, message])
  return {
    ref,
  }
}
